export default {
  systemName: "迪迪兔(智信)后台管理"
};